import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { newRelicConnection } from '../../newRelicConnection'

export default class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error }
  }

  componentDidCatch (error, errorInfo) {
    newRelicConnection.noticeError(error, {
      componentStack: errorInfo?.componentStack
    })
  }

  render () {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }
      return (
        <div className='p-6 text-center' role='alert'>
          <h2 className='text-lg font-semibold text-red-600 mb-2'>Something went wrong</h2>
          <p className='text-sm text-gray-600 mb-4'>An unexpected error has occurred. Our team has been notified.</p>
          <button
            type='button'
            className='px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm'
            onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node
}
